module.exports = __webpack_public_path__ + "static/media/decta.93d3b199.svg";